module.exports = __webpack_public_path__ + "static/media/other.2faaf296.svg";